
export const BAND1_COST = 600;
export const BAND2_COST = 650;
export const BAND3_COST = 700;
